import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CfPopoverBase } from 'components/popover-host/popover-interface';
import { PopoverController } from 'providers/popover-controller';
import { ExerciseStat } from '@cf-shared/data-model/user-state';

import { LL } from 'i18n/i18n.service';
export interface CsViewNotesPopoverParams {
  exerciseId?: string;
  exerciseName?: string;
  note: string;
  stat?: ExerciseStat;
  titleKey?: string;  // defaults to 'pinnedNote.viewTitle'
}

export interface CsViewNotesResult {
  action: 'edit' | 'close';
}

@Component({
  selector: 'cs-view-notes-popover',
  templateUrl: 'cs-view-notes-popover.html',
  host: { 'class': 'view-notes-popover' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsViewNotesPopover extends CfPopoverBase {
  protected LL = LL;
  @Input() params: CsViewNotesPopoverParams;

  get title(): string {
    if (this.params.titleKey === 'setNote.viewTitle') {
      return LL.setNote.viewTitle();
    }
    return LL.pinnedNote.viewTitle();
  }

  static async present(
    popoverCtrl: PopoverController,
    targetElement: HTMLElement,
    params: CsViewNotesPopoverParams
  ): Promise<CsViewNotesResult | null> {
    const result = await popoverCtrl.present(
      CsViewNotesPopover,
      { params },
      {
        targetFromElement: targetElement,
        animate: true,
        showBackdrop: true,
        bottomSheet: true
      }
    );

    return result.data;
  }

  constructor(
    private popoverCtrl: PopoverController
  ) {
    super();
  }

  onWillDismiss(_data: any) {
    // data is already set via dismiss call
  }

  onEditClick() {
    void this.popoverCtrl.dismiss(this, {
      data: { action: 'edit' }
    });
  }

  onCloseClick() {
    void this.popoverCtrl.dismiss(this, {
      data: { action: 'close' }
    });
  }
}
